/*
 * Created by: bpietroiu
 * Date: 7/16/13  10:33 AM
 */

TS.ns('TS.domain.properties.fields');

/**
 * @class TS.domain.properties.fields.AdaptiveLookupListField
 * @extends TS.domain.properties.fields.SelectionListField
 */
TS.domain.properties.fields.AdaptiveLookupListField = new Class(
/** @lends TS.domain.properties.fields.AdaptiveLookupListField# */
{
    Extends: TS.domain.properties.fields.SelectionListField,

    initialize: function (owner, config) {
        var me = this;
        me.parent(owner, config);
        Object.defineProperty(me, 'Model', {
            get: function () {
                return me.ListSource;
            }
        });
    },
});

TS.domain.properties.ListField.types['adaptiveLookup'] = TS.domain.properties.fields.AdaptiveLookupListField;
